import React from 'react';
import HeroBg from '../../img/hero-bg-3.jpg';
import './heroSection.scss';

const HeroSection = () => {
  return (
    <div
      className="main overflow-hidden "
      style={{
        background: `url(${HeroBg})`,
        // backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        backgroundSize: 'cover',
        // height: '100%',
        height: '680px',
      }}
    >
      <div className="container mx-auto py-24">
        <div className="w-full md:w-2/4">
          <div className="glass-effect rounded-md my-12 p-8">
            <h1 className="text-3xl text-main md:text-6xl  font-semibold my-4">
              Find The Best Doctor Near By You!
            </h1>
            <p className="primary-color font-semibold text-base md:text-xl leading-7">
              Qualified doctors available six days a week, view our timetable to
              make an appointment. Please feel free to contact our friendly
              reception staff with any general or medical enquiry.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
